module.exports = __webpack_public_path__ + "static/Implant bridge smile before-5dc50be3df3aab8dc9ef0d267ed1451c.jpg";